'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTranslatorProps = exports.withTranslator = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _shallowequal = require('shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _componentHelper = require('./component-helper.js');

var _translatorType = require('./translatorType');

var _translatorType2 = _interopRequireDefault(_translatorType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create props injected in composants.
 * @param  {Object} translator  gandi translator object
 * @return {Object}
 */
//  weak

var createTranslatorProps = function createTranslatorProps(translator) {
  var translate = translator.translate,
      _localize = translator.localize,
      createNumberFormat = translator.createNumberFormat,
      mapCurrencyISOToSymbol = translator.mapCurrencyISOToSymbol;


  return {
    __: translate,

    /**
     * Format dates.
     * @param  {Object} date     Date to format
     * @param  {String} format   Output format
     * @return {String}          Date formatted
     */
    formatDate: function formatDate(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'LLL Z';
      return _localize(date).format(format);
    },

    /**
     * Format prices.
     * @param  {String | Number} price      Price to format
     * @param  {String} currency            Currency
     * @return {String}                     Price formatted
     */
    formatNumber: function formatNumber(number) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return createNumberFormat((0, _extends3.default)({ style: 'decimal' }, options)).format(number);
    },

    /**
     * Format prices.
     * @param  {String | Number} price      Price to format
     * @param  {String} currency            Currency
     * @return {String}                     Price formatted
     */
    formatPrice: function formatPrice(price, currency) {
      var options = { style: 'currency' };
      // $FlowIssue
      if (currency) options.currency = currency;
      return createNumberFormat(options).format(price);
    },

    /**
     * Return the currency symbol according to current locale from it's ISO code.
     * Use the localeData provided by Intl polyfill to map.
     * @param string   currencyISO   Currency ISO string
     * @return string
     */
    formatCurrency: mapCurrencyISOToSymbol,

    /**
     * Low level utility to create a localized instance of moment.
     * Do not use outside this module
     * @param  {Object} date     Date to format
     * @return {moment}
     */
    localize: function localize(date) {
      return _localize(date);
    }
  };
};

/**
 * Inject translations function into props of a wrapper component.
 * @param  {Component} WrappedComponent   Wrapper component
 * @return {Component}                    Decorated component
 */
var withTranslator = function withTranslator(options) {
  return function (WrappedComponent) {
    var _class, _temp2;

    var defaultOptions = {
      propsNamespace: ''
    };

    var finalOptions = (0, _extends3.default)({}, defaultOptions, options);

    var WithTranslator = (_temp2 = _class = function (_React$Component) {
      (0, _inherits3.default)(WithTranslator, _React$Component);

      function WithTranslator() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, WithTranslator);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithTranslator.__proto__ || (0, _getPrototypeOf2.default)(WithTranslator)).call.apply(_ref, [this].concat(args))), _this), _this.i18nProps = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
      }

      (0, _createClass3.default)(WithTranslator, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          // Handle first render, for which componentWillReceiveProps has not been called
          this.updateI18NProps(this.context);
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps, nextContext) {
          var toUpdate = !(0, _shallowequal2.default)(this.context.translator, nextContext.translator);
          if (toUpdate) {
            this.updateI18NProps(nextContext);
          }
        }
      }, {
        key: 'updateI18NProps',
        value: function updateI18NProps(context) {
          this.i18nProps = createTranslatorProps(context.translator);
        }
      }, {
        key: 'render',
        value: function render() {
          var finalProps = (0, _componentHelper.getProps)(this.props, this.i18nProps, finalOptions.propsNamespace);
          return _react2.default.createElement(WrappedComponent, finalProps);
        }
      }]);
      return WithTranslator;
    }(_react2.default.Component), _class.displayName = 'WithTranslator(' + (0, _componentHelper.getDisplayName)(WrappedComponent) + ')', _class.propTypes = {
      res: _propTypes2.default.object
    }, _class.contextTypes = {
      translator: _translatorType2.default
    }, _class.WrappedComponent = WrappedComponent, _temp2);


    var HoistedComponent = (0, _hoistNonReactStatics2.default)(WithTranslator, WrappedComponent);
    HoistedComponent.preFetch = function preFetch(props) {
      var translator = props.res.locals.translator;

      var i18nProps = createTranslatorProps(translator);

      // Call child preFetch if any
      var wrappedPreFetch = (0, _componentHelper.getDataDependency)(WrappedComponent, 'preFetch');
      if (!wrappedPreFetch) {
        return null;
      }

      var wrapperComponentProps = (0, _componentHelper.getProps)(props, i18nProps, finalOptions.propsNamespace);

      return wrappedPreFetch(wrapperComponentProps);
    };

    return HoistedComponent;
  };
};

exports.withTranslator = withTranslator;
exports.createTranslatorProps = createTranslatorProps;


//////////////////
// WEBPACK FOOTER
// ./~/@gandi/react-translate/dist/react/withTranslator.js
// module id = 109
// module chunks = 0